<template>
    <kt-panel>
        <kt-panel-body>
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                <p class="mb-2 text-muted">{{ $t('security.disabled_settings.description') }}</p>
                <button type="button" class="btn btn-brand" :disabled="loading" @click="check">
                    <i class="fa fa-search" v-if="!loading"></i>
                    <span class="spinner-border spinner-border-sm" v-else></span>
                    {{ loading ? $t('security.disabled_settings.checking') : $t('security.disabled_settings.check') }}
                </button>
            </div>

            <template v-if="report">
                <div class="row mb-4">
                    <div class="col-6 col-md-3 mb-2" v-for="item in summaryItems" :key="item.key">
                        <div class="border rounded p-3 text-center h-100">
                            <div class="text-muted small">{{ item.title }}</div>
                            <div class="h4 mb-0" :class="item.danger && item.value > 0 ? 'text-danger' : ''">
                                {{ item.value }}
                            </div>
                        </div>
                    </div>
                </div>
                <p class="text-muted small">{{ $t('security.disabled_settings.checked_at') }}: {{ report.checked_at }}</p>

                <div class="alert alert-success" v-if="report.gateways.length === 0">
                    {{ $t('security.disabled_settings.no_issue') }}
                </div>

                <div class="table-responsive" v-else>
                    <table class="table table-striped">
                        <thead>
                        <tr style="font-size: 0.89rem;">
                            <td class="text-center">#</td>
                            <td class="text-center">{{ $t('label.user_full_name') }}</td>
                            <td class="text-center">{{ $t('label.farsi_name') }}</td>
                            <td class="text-center">{{ $t('security.disabled_settings.terminal_number') }}</td>
                            <td class="text-center">{{ $t('label.server_ip_limitation') }}</td>
                            <td class="text-center">{{ $t('label.callback_address_limitation') }}</td>
                            <td class="text-center">{{ $t('label.referer_limitation') }}</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(gateway, index) in report.gateways" :key="index">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td class="text-center">
                                <router-link v-if="gateway.user_id" :to="`/users/${gateway.user_id}/details`">{{ gateway.user }}</router-link>
                            </td>
                            <td class="text-center">
                                <router-link v-if="gateway.shop_id" :to="`/gateways/${gateway.shop_id}/details`">{{ gateway.shop }}</router-link>
                            </td>
                            <td class="text-center">{{ gateway.terminal_number }}</td>
                            <td class="text-center" v-for="field in limitationFields" :key="field">
                                <i class="fa fa-check text-success" v-if="gateway[field]"></i>
                                <i class="fa fa-times text-danger" v-else></i>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import toastr from "toastr";
import { userService } from "@/common/api.service";

export default {
    name: "DisabledSecuritySettings",
    data() {
        return {
            loading: false,
            report: null,
            limitationFields: ['server_ip_limitation', 'callback_address_limitation', 'referer_limitation'],
        }
    },
    computed: {
        summaryItems() {
            const summary = this.report.summary
            return [
                { key: 'checked', title: this.$t('security.disabled_settings.checked_gateways'), value: summary.checked_gateways, danger: false },
                { key: 'server_ip', title: this.$t('security.disabled_settings.server_ip_disabled'), value: summary.server_ip_limitation_disabled, danger: true },
                { key: 'callback', title: this.$t('security.disabled_settings.callback_disabled'), value: summary.callback_address_limitation_disabled, danger: true },
                { key: 'referer', title: this.$t('security.disabled_settings.referer_disabled'), value: summary.referer_limitation_disabled, danger: true },
            ]
        },
    },
    methods: {
        check() {
            this.loading = true
            userService.getDisabledSecuritySettings().then(response => {
                this.report = response.data.data
            }).catch(error => {
                const message = error.response && error.response.data && error.response.data.message
                toastr.error(message || this.$t('security.disabled_settings.failed'))
            }).finally(() => {
                this.loading = false
            })
        },
    },
}
</script>
